import { render, staticRenderFns } from "./AvatarV3.vue?vue&type=template&id=2e5eaad2&scoped=true&"
import script from "./AvatarV3.vue?vue&type=script&lang=js&"
export * from "./AvatarV3.vue?vue&type=script&lang=js&"
import style0 from "./AvatarV3.vue?vue&type=style&index=0&id=2e5eaad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5eaad2",
  null
  
)

export default component.exports